"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTimestamp = exports.normalizeTimestamp = exports.getDefaultDateRangeArray = exports.getDefaultDateRange = exports.formatDate = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(timezone_1.default);
const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};
exports.formatDate = formatDate;
const getDefaultDateRange = () => {
    const endDate = new Date();
    endDate.setHours(23, 59, 59, 999);
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1);
    startDate.setHours(0, 0, 0, 0);
    return [startDate, endDate];
};
exports.getDefaultDateRange = getDefaultDateRange;
const getDefaultDateRangeArray = () => {
    const endDate = new Date();
    endDate.setHours(23, 59, 59, 999); // Set to 23:59:59.999
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1); // Subtract one month
    startDate.setHours(0, 0, 0, 0); // Set to 00:00:00.000
    return [startDate, endDate];
};
exports.getDefaultDateRangeArray = getDefaultDateRangeArray;
const normalizeTimestamp = (ts) => {
    return ts < 1e12 ? ts * 1000 : ts;
};
exports.normalizeTimestamp = normalizeTimestamp;
const formatTimestamp = (ts) => {
    const ms = (0, exports.normalizeTimestamp)(ts);
    return (0, dayjs_1.default)(ms).tz(dayjs_1.default.tz.guess()).format('DD-MM-YYYY HH:mm');
};
exports.formatTimestamp = formatTimestamp;
